import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  messages: [],
  progress: [],
  progress_id: '',
  is_has_next_messages: false,
  is_pause: false,
  is_end_message: false,
  is_hide_user_messages: false,
  is_finish: false,
  isLoading: false,
  error: false,
  lesson_id: '',
  step: '',
  session_id: '',
  isDisableHandleText: false,
  dataSavePhrase: null,
  savedPhrase: null,
};

export const converstationSlice = createSlice({
  name: 'converstation',
  initialState,
  reducers: {
    updateConversationData: (state: any, action) => {
      Object.assign(state, action.payload);
    },
    resetConversationData: (state: any) => {
      Object.assign(state, initialState);
    },
    updateIsDisableHandleText: (state: any, action) => {
      state.isDisableHandleText = action.payload
    },
    updateDataSavePhrase: (state: any, action) => {
      state.dataSavePhrase = action.payload
    },
    updateSavedPhrase: (state: any, action) => {
      state.savedPhrase = action.payload
    },
  }
})

export const {
  updateConversationData,
  resetConversationData,
  updateIsDisableHandleText,
  updateDataSavePhrase,
  updateSavedPhrase,
} = converstationSlice.actions

export default converstationSlice.reducer
